import { render, staticRenderFns } from "./ImageGridUploader.vue?vue&type=template&id=97c902c2&scoped=true&"
import script from "./ImageGridUploader.vue?vue&type=script&lang=js&"
export * from "./ImageGridUploader.vue?vue&type=script&lang=js&"
import style0 from "./ImageGridUploader.vue?vue&type=style&index=0&id=97c902c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c902c2",
  null
  
)

export default component.exports